<template>
  <div v-if="!readOnly && !field.readOnly" :ref="inputRef">
    <div class="input-group">
      <label>{{ field.label }} {{ field.required ? '*' : '' }}</label>
    </div>
    <v-row class="pt-2">
      <v-col v-for="(item, index) in fieldItems" :key="index" :class="field.row ? 'xs6 sm4 md3 lg3' : 'xs12'">
        <v-checkbox :input-value="parsedFieldValue"
                    :disabled="field.disabled"
                    :class="field.class"
                    :label="item[field.itemText] || item"
                    :value="item[field.itemValue] || item"
                    @change="onCheckboxChange" />
      </v-col>
    </v-row>
    <p v-if="field.hint" class="grey--text mb-0">
      {{ field.hint }}
    </p>
  </div>
  <div v-else :class="{'reg-information': !small, 'reg-information-small': small}">
    <label>{{ field.label }}</label>
    <p>{{ readOnlyFieldValue }}</p>
  </div>
</template>

<script>
import { defineComponent, ref, computed, watch, getCurrentInstance, toRef } from 'vue'
import { useDynamicField } from '../composables/useDynamicField'

export default defineComponent({
  name: 'DynamicCheckboxGroup',
  props: {
    value: {
      type: Object,
      default: () => ({})
    },
    field: {
      type: Object,
      required: true
    },
    readOnly: {
      type: Boolean,
      default: false
    },
    box: {
      type: Boolean,
      default: false
    },
    small: {
      type: Boolean,
      default: false
    },
    isValidating: {
      type: Boolean,
      default: false
    },
    itemKey: {
      type: String,
      default: ''
    }
  },
  emits: ['input', 'change'],
  setup(props, { emit, expose }) {
    const instance = getCurrentInstance()
    const $store = instance?.proxy?.$store
    
    const {
      fieldValue,
      fieldChanged,
      inputRef,
      hasError
    } = useDynamicField({
      value: toRef(props, 'value'),
      field: props.field,
      readOnly: props.readOnly,
      isValidating: toRef(props, 'isValidating'),
      itemKey: props.itemKey,
      emptyValue: [],
      emit
    })

    const parsedFieldValue = ref([])

    const readOnlyFieldValue = computed(() => {
      return fieldValue.value.join(', ')
    })

    const fieldItems = computed(() => {
      if (props.field.items) {
        return props.field.items
      } else if (props.field.dataSource && props.field.dataSource.modelName) {
        return $store.state[props.field.dataSource.state || 'dynamicModule'][props.field.dataSource.modelName]
      }
      return []
    })

    const onFieldValueChange = (value) => {
      if (!value || String(value) === '') {
        parsedFieldValue.value = []
      } else {
        parsedFieldValue.value = String(value).trim().split('|')
      }
    }

    const onCheckboxChange = (value) => {
      fieldValue.value = value.join('|')
      fieldChanged(fieldValue.value)
    }

    watch(() => fieldValue.value, onFieldValueChange, { immediate: true })

    // Expose properties for DynamicForm validation
    expose({
      hasError,
      validate: () => inputRef.value?.validate?.()
    })

    return {
      fieldValue,
      parsedFieldValue,
      readOnlyFieldValue,
      fieldItems,
      onCheckboxChange,
      inputRef
    }
  }
})
</script>

<style lang="scss">
</style>